module.exports = __webpack_public_path__ + "static/img/Eniksen_Logo_invert_def.5ce5c129.png";